export default "__VITE_ASSET__DmPmy4UQ__"